import { useState, useEffect } from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Box,
  CircularProgress,
  useMediaQuery,
  useTheme,
} from '@mui/material';
import { getItemDebug } from '../../services/items';

interface DebugDialogProps {
  open: boolean;
  onClose: () => void;
  itemId: string;
}

export default function DebugDialog({ open, onClose, itemId }: DebugDialogProps) {
  const theme = useTheme();
  const mobile = useMediaQuery(theme.breakpoints.down('sm'));
  const [data, setData] = useState<any>(null);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (open) {
      setLoading(true);
      setData(null);
      getItemDebug(itemId)
        .then(setData)
        .catch((err) => setData({ error: String(err) }))
        .finally(() => setLoading(false));
    }
  }, [open, itemId]);

  return (
    <Dialog open={open} onClose={onClose} fullScreen={mobile} maxWidth="md" fullWidth>
      <DialogTitle>Debug Info</DialogTitle>
      <DialogContent>
        {loading ? (
          <Box sx={{ display: 'flex', justifyContent: 'center', py: 4 }}>
            <CircularProgress />
          </Box>
        ) : (
          <Box
            component="pre"
            sx={{
              fontFamily: 'monospace',
              fontSize: '0.8rem',
              overflow: 'auto',
              whiteSpace: 'pre-wrap',
              wordBreak: 'break-word',
              m: 0,
            }}
          >
            {JSON.stringify(data, null, 2)}
          </Box>
        )}
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Close</Button>
      </DialogActions>
    </Dialog>
  );
}
